import React from 'react';
import styled, { css } from 'styled-components';
import { Nav } from '@catalogo/core-nav';
import FlagNew from '@catalogo/ui-americanas-desktop-header/src/components/bottom/department-menu/components/flag-new';

const Item = ({ title, flag }) => (
  <ItemInner>
    {title}
    {flag === 'Novo' && <FlagNewUI />}
  </ItemInner>
);

const ItemMenu = ({ item, nivel = 0, endItem = false, dispatchMetrics }) => {
  const countChildren = item?.children?.length || 0;

  return (
    <Container>
      <Wrapper
        isTitle={nivel === 0}
        marginBottom={!!item.link && endItem && nivel === 1}
        hasLefttMargin={nivel === 2}
        highlight={!item.link}
      >
        {item.link ? (
          <Link
            to={item.link}
            onClick={() =>
              dispatchMetrics('event:track', {
                event: 'c:click',
                action: 'click',
                category: 'menu-header',
                label: item.title,
              })
            }
          >
            <Item title={item.title} flag={item.flag} />
          </Link>
        ) : (
          <Item title={item.title} flag={item.flag} />
        )}
      </Wrapper>
      {!!countChildren &&
        item.children.map((category, index) => (
          <ItemMenu key={category.id} item={category} nivel={nivel + 1} endItem={index + 1 === countChildren} />
        ))}
    </Container>
  );
};

export default ItemMenu;

const Container = styled.div`
  break-inside: avoid;
`;

const Wrapper = styled.div`
  ${({ isTitle, hasLefttMargin, marginBottom, highlight }) => css`
    color: ${({ theme }) => theme.textColor};
    width: 260px;
    display: block;
    padding: 5px 0 5px 32px;
    font-size: 14px;
    transition: color 0.3s;
    ${
      highlight &&
      css`
        font-weight: bold;
      `
    }
    ${
      isTitle &&
      css`
        display: block;
        font-weight: 700;
        font-size: 20px;
        cursor: default;
        margin-bottom: 8px;

        > ${Link} {
          text-decoration: underline;
        }
      `
    }
    ${
      hasLefttMargin &&
      css`
        margin-left: 10px;
      `
    }
    ${
      marginBottom &&
      css`
        margin-bottom: 30px;
      `
    }
  `}
`;

const Link = styled(Nav)`
  transition: color 0.3s;
  color: #666;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
    color: ${({ theme }) => theme.primaryColor};
  }
`;

const ItemInner = styled.span`
  position: relative;
`;

const FlagNewUI = styled(FlagNew)`
  left: calc(100% + 16px);
`;
